import React from "react";

const RequirementsSection = () => {
  return (
    <section className="bg-paket-lms px-6 md:px-24 py-8 -mt-2 mb-6 bg-white">
      <div className="flex flex-col mx-auto text-center mb-4 md:mb-5 items-center">
        <h2 className="text-2xl font-body font-bold align-center sm:text-4xl leading-relaxed text-white">
          Persyaratan Program
        </h2>
        <div className="border-2 md:border-4 border-accent-100 rounded-full w-40 mt-3 md:mt-5" />
      </div>
      <div className="grid md:grid-cols-2 gap-1 md:gap-6 max-w-[1200px] mx-auto">
        {[
          {
            icon: "/img/course/icon-computer.png",
            alt: "Laptop",
            title: "Memiliki Laptop",
            specs: [
              { label: "CPU", value: "x64" },
              { label: "OS", value: "Windows 7, macOS, Linux" },
            ],
          },
          {
            icon: "/img/course/icon-handphone.png",
            alt: "Handphone",
            title: "Handphone",
            specs: [{ label: "OS", value: "Android" }],
          },
        ].map((item, i) => (
          <div
            key={i}
            className="px-3 md:px-8 py-2 border rounded-lg shadow-[4px_4px_10px_0px_rgba(0,128,128,0.5)] flex items-start gap-3 mt-4 bg-white"
          >
            <img
              src={item.icon}
              alt={item.alt}
              className="mt-2 mb-4 w-24 h-24"
            />
            <div className="py-4 px-2">
              <h3 className="text-lg font-semibold mb-2">{item.title}</h3>
              <ul className="list-disc list-outside pl-5 space-y-1">
                {item.specs.map((spec, idx) => (
                  <li key={idx} className="text-base">
                    {spec.label} : {spec.value}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default RequirementsSection;
